import fetchGraphQL from '../fetcher'
import type { Queryer } from '../types'

const getGlobalElements: Queryer = async (options) => {
  const query = `
    fragment LinkParts on Link {
      label
      target
      isExternal
      opensInNewTab
      linkIcon
    }
    query getGlobalItemsCollection($siteTag: String, $preview: Boolean = false) {
      globalSettingsCollection(
        preview: $preview
        limit: 1
        where: {
          contentfulMetadata: {
            tags_exists: true
            tags: { id_contains_all: [$siteTag] }
          }
        }
      ) {
        items {
          customersAlsoBoughtProducts
          filterCollections
          topSearchTerms
          cartPromo
        }
      }
      navigationCollection(
        limit: 1,
        where: {
          contentfulMetadata: {
            tags_exists: true
            tags: {
              id_contains_all: [$siteTag]
            }
          }
        }
      ) {
        items {
        primaryNavTitle
          preNavLinksCollection {
            items {
              ...on Link {
                ...LinkParts
              }
            }
          }
          preHeadLinkDelay
          primaryNavListCollection {
          items {
            ...on MenuCategory {
              __typename
              linkLabel
              categoryTitle
              hideCategoryTitleOnDesktop
              linkListCollection {
                items {
                  ...on Link {
                    ...LinkParts
                  }
                }
              }
            }
            ...on Link {
              __typename
              ...LinkParts
            }
          }
        }
          secondaryNavListCollection {
            items {
              label
              target
              isExternal
              opensInNewTab
            }
          }
        }
      }
      footerCollection(
        limit: 1
        where: {
          contentfulMetadata: {
            tags_exists: true
            tags: { id_contains_all: [$siteTag] }
          }
        }
      ) {
        items {
          disclaimerCopy
          copyrightText
          socialIconListCollection {
            items {
              ...LinkParts
            }
          }
          primaryLinkGroupsCollection(limit: 4) {
            items {
              categoryTitle
              linkListCollection {
                items {
                  ...LinkParts
                }
              }
            }
          }
          bottomLinksCollection(limit: 5) {
            items {
              ...LinkParts
            }
          }
        }
      }
    }
  `

  const result = await fetchGraphQL({ query, ...options })

  if (result.errors) {
    return result.errors
  }

  return {
    globalSettings: result?.data?.globalSettingsCollection?.items?.[0] || {},
    navigation: result?.data?.navigationCollection?.items?.[0] || {},
    footer: result?.data?.footerCollection?.items?.[0] || {},
  }
}

export default getGlobalElements
